import React from 'react';
interface RangeSliderProps {
  id: string;
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  accent: string;
  onChange: (value: number) => void;
  ariaValueText?: string;
}
export function RangeSlider({
  id,
  label,
  value,
  min,
  max,
  step,
  accent,
  onChange,
  ariaValueText
}: RangeSliderProps) {
  const pct = max === min ? 0 : (value - min) / (max - min) * 100;
  const track = `linear-gradient(to right, ${accent} 0%, ${accent} ${pct}%, #24272C ${pct}%, #24272C 100%)`;
  return <input id={id} className="range" type="range" min={min} max={max} step={step} value={value} aria-label={label} aria-valuetext={ariaValueText} onChange={e => onChange(Number(e.target.value))} style={{
    '--accent': accent,
    '--track': track
  } as React.CSSProperties} data-id="element-100" data-mp="9tjjf77i0r0k" />;
}